export default __webpack_public_path__ + "static/media/play-white.22950853.svg";